import { defineComponent, openBlock, createBlock, Transition, withCtx, renderSlot } from 'vue';

var script = /*#__PURE__*/ defineComponent({
    __name: 'UiTransition',
    props: {
        /** Наименование анимации перехода */
        name: {
            type: String,
            default: 'fade',
        },
        /** Запуск анимации перехода при изначальной отрисовке */
        appear: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (openBlock(), createBlock(Transition, {
                name: 'omnica-transition-' + __props.name,
                appear: __props.appear
            }, {
                default: withCtx(() => [
                    renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["name", "appear"]));
        };
    }
});

script.__file = "packages/transition/src/UiTransition.vue";

export { script as default };
